const BASE_URL = process.env.REACT_APP_DOMAIN;

module.exports = { BASE_URL };
